import { KeepAwake } from "@capacitor-community/keep-awake";

export async function enableKeepAwake(): Promise<void> {
    const { isSupported } = await KeepAwake.isSupported();
    if (!isSupported) return;

    await KeepAwake.keepAwake();
}

export async function disableKeepAwake(): Promise<void> {
    const { isSupported } = await KeepAwake.isSupported();
    if (!isSupported) return;

    await KeepAwake.allowSleep();
}
